import React from 'react';
import { Box } from '@wix/design-system';
import styles from './TldPromotion.scss';
import { TldPromotionContent } from './TldPromotionContent';
export const TldPromotionComp = _ref => {
  let {
    tld,
    pricing,
    description,
    id,
    Label,
    PromotionBadge,
    PromotionPrice
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    key: id,
    padding: "SP2 45px",
    direction: "vertical",
    gap: "SP4",
    minHeight: "205px",
    align: "space-between",
    position: "relative",
    className: styles.gridItem
  }, /*#__PURE__*/React.createElement(TldPromotionContent, {
    tld: tld,
    pricing: pricing,
    description: description,
    Label: Label,
    PromotionBadge: PromotionBadge,
    PromotionPrice: PromotionPrice
  }));
};
//# sourceMappingURL=TldPromotion.js.map